<template>
  <div class="km__modules__expressanfrage km__popup">
    <button class="km__button--back" type="button" name="back" @click="closeForm" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="closeForm" aria-label="close"></button>
    <h2 class="km__popup--heading">{{ $t("konf_expressProduktionAnfragen") }}</h2>
    <div class="km__popup--content">
      <h2>{{ $t('konf_Coming') }}</h2>
      <p v-html="$t('konf_SupportExpress')"></p>

      <ul class="km__list--modules">
        <ModuleTextInput v-model="name" :text="$t('Label_Ihrname')" :error="hasError('name')"/>
        <ModuleTextInput v-model="termin" :text="$t('konf_IhrWunschtermin')" :error="hasError('termin')"/>
        <ModuleTextInput v-model="productAndAmount" :text="$t('konf_productwithNumber')"
                         :error="hasError('productAndAmount')"/>
        <ModuleTextInput v-model="ort" :text="$t('konf_expressLieferort')" :error="hasError('ort')"/>
        <li :class="{error:hasError('message')}" class="km__list__element--modules">
          <label class="km__label--text">{{ $t('konf_contact_body') }}</label>
          <textarea class="" v-model="message" rows="10"/>
        </li>
      </ul>
      <p>{{ $t('konf_contact_how') }}</p>
      <ul class="km__list--modules">
        <ModuleTextInput v-model="email" :text="$t('konf_Email')" :error="hasError('email')"/>
        <ModuleTextInput v-model="telefon" :text="$t('konf_Tel')" :error="hasError('telefon')"/>
      </ul>
      <ul class="km__list--modules">
        <li class="km__list__element--modules" :class="{error:hasError('acceptPrivacy')}">
          <input type="checkbox" v-model="acceptPrivacy">
          <label class="km__label--text">{{ $t("konf_acceptSavingOfDataHeader") }}</label>
          <p>{{ $t("konf_acceptSavingOfDataParagraph1") }}</p>
          <p>
            {{ $t("km_privacy_legal_prelink") }}
            <a :href="datenschutzLink" target="_blank">{{ $t("Datenschutzerklaerung") }}</a>
            {{ $t("km_privacy_legal_postlink") }}
          </p>
        </li>
      </ul>
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard" @click="closeForm">{{ $t("konf_Close") }}</button>
      <button class="km__button--standard" @click="submit">{{ $t("konf_Submit") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, Ref, ref} from "vue";
import {getExpressAnfrageErrors} from "@km/components/popups/expressAnfrageValidation";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import {useStore} from "vuex";
import ModuleTextInput from "@km/components/popups/ModuleTextInput.vue";
import {LinksToWebsite} from "@k/js/databaseInterfaceClasses";
import {ExpressanfragePostData} from "@k/js/interfaceDataClasses";
import {AnfragenController} from "@k/js/controllerModules/anfragenController";
import {owayoModelWrapper} from "@km/js/initMobile";
import {EventVerteiler} from "@k/global/eventVerteiler";


const formdata = {
  name: ref(""),
  termin: ref(""),
  productAndAmount: ref(""),
  ort: ref(""),
  message: ref(""),
  email: ref(""),
  telefon: ref(""),
  acceptPrivacy: ref(false)
}
const store = useStore();
const errors = ref([]) as Ref<string[]>;


const name = formdata.name;
const termin = formdata.termin;
const productAndAmount = formdata.productAndAmount;
const ort = formdata.ort;
const message = formdata.message;
const email = formdata.email;
const telefon = formdata.telefon;
const acceptPrivacy = formdata.acceptPrivacy;
const submit = () => {
  errors.value = getExpressAnfrageErrors(formdata);
  if (errors.value.length > 0) {
    return;
  }
  const anfrageData = new ExpressanfragePostData();
  anfrageData.ansprechpartner= formdata.name.value;
  anfrageData.wunschtermin= formdata.termin.value;
  anfrageData.description= formdata.message.value;
  anfrageData.productAndNumber= formdata.productAndAmount.value;
  anfrageData.email= formdata.email.value;
  anfrageData.tel= formdata.telefon.value;
  anfrageData.anfrage= "Expressanfrage";
  anfrageData.lieferOrt= formdata.ort.value;
  AnfragenController.sendexpressAnfrage(anfrageData, owayoModelWrapper).then(() => {
    EventVerteiler.broadcast("displayHintEventToBeTranslated", {message:"Kontaktformular_Okay"});

    closeForm();
  });

};
const hasError = name => errors.value.indexOf(name) > -1;
const closeForm = () => store.commit("SET_OVERLAY_CLOSED", OverlayNames.expressanfrage);
const datenschutzLink = computed(() => store.getters["ModelStore/getLinkToWebsite"](LinksToWebsite.privacyterms));

</script>

<style scoped>

.error {
  border: 1px solid red;
}

.km__modules__expressanfrage {
  z-index: 999;
  overflow-y: scroll;
}

.km__list__element--modules {
  margin-bottom: 20px;
}

.km__label--text {
  margin-bottom: 5px;
}

:deep(strong) {
  font-weight: bold;
}

textarea {
  width: 100%;
}
</style>
